import { apiFetch } from "@/lib/api";

export type PeekopVertical =
  | "real_estate"
  | "insurance"
  | "freelance"
  | "mortgage"
  | "legal"
  | "healthcare"
  | "finance"
  | "other";

export interface UserPreferences {
  vertical?: PeekopVertical;
  businessName?: string;
  onboardingCompletedAt?: string;
  timezone?: string;
  defaultReminderDays?: number;
  defaultExpirationDays?: number;
  emailSignature?: string;
  notificationEmailOnView?: boolean;
  notificationEmailOnSign?: boolean;
  notificationEmailOnDecline?: boolean;
  notificationEmailOnExpire?: boolean;
}

export interface CurrentUser {
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  role: string;
  organizationId: string;
  organization: { id: string; name: string; plan: string };
  preferences: UserPreferences;
  onboardingCompleted: boolean;
}

export async function getCurrentUser(): Promise<CurrentUser> {
  return apiFetch<CurrentUser>("/api/users/me");
}

export async function updatePreferences(
  prefs: Partial<UserPreferences>
): Promise<{ preferences: UserPreferences }> {
  return apiFetch<{ preferences: UserPreferences }>("/api/users/me", {
    method: "PATCH",
    body: prefs,
  });
}

export async function completeOnboarding(data: {
  vertical: PeekopVertical;
  businessName?: string;
}): Promise<{ vertical: PeekopVertical; onboardingCompletedAt: string }> {
  return apiFetch("/api/users/me/onboarding", {
    method: "POST",
    body: data,
  });
}
